// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-toggle-switch-docs',
    templateUrl: './toggle-switch.docs.generated.html',
})
export class UIToggleSwitchDocs { }
